import React from 'react'
import { Col, RadioButton, Radio } from 'core/components/ui'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { InputWrapper, InterTitle } from '../../styled'

const FormItem = ({ vehicle, onChange }) => {
  const handleChange = e => {
    const { value } = e.target
    const extendedVehicle = {
      ...vehicle,
      secondTyres: Number(value)
    }
    onChange(extendedVehicle)
  }

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle>
        <FormattedMessage id="tradeIn-state-tires-4" />
      </InterTitle>

      <InputWrapper type="flex">
        <Col span={24}>
          <Radio.Group
            buttonStyle="solid"
            value={vehicle && vehicle.secondTyres}
            onChange={handleChange}
          >
            <RadioButton value={1}>
              <FormattedMessage id="tradeIn-state-tires-4-reply-1" />
            </RadioButton>
            <RadioButton value={0}>
              <FormattedMessage id="tradeIn-state-tires-4-reply-2" />
            </RadioButton>
          </Radio.Group>
        </Col>
      </InputWrapper>
    </Col>
  )
}

FormItem.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired
}

export default { FormItem }
